module.exports = __webpack_public_path__ + "static/body_10-cc6af4a457717d7d2b8af3136a5e8c07.png";